import { FC, useCallback, useEffect, useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import { FeedbackQuestion } from '@treams/treams-network';

import FeedbackQuestionCard from '../FeedbackQuestionCard';

const Grid = styled(Box)`
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 20px 12px;
`;

type Props = {
	searchQuery: string;
	questions: FeedbackQuestion[];
	selectedQuestions: FeedbackQuestion[];
	onChangeSelectedQuestions: (questions: FeedbackQuestion[]) => void;
};

const FeedbackLibraryAccordionItems: FC<Props> = ({
	searchQuery,
	questions,
	selectedQuestions,
	onChangeSelectedQuestions,
}) => {
	const { localize } = useLocalize();

	const [displayedQuestions, setDisplayedQuestions] = useState<FeedbackQuestion[]>(questions);

	useEffect(() => {
		if (searchQuery.length > 0) {
			const filteredQuestions = questions.filter((question) =>
				localize(question.text).text.toLowerCase().includes(searchQuery.toLowerCase()),
			);

			setDisplayedQuestions(filteredQuestions);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery, questions]);

	const onSelect = useCallback(
		(question: FeedbackQuestion) => {
			let localSelectedQuestions = selectedQuestions ?? [];

			if (localSelectedQuestions.some(({ id }) => id === question.id)) {
				localSelectedQuestions = localSelectedQuestions.filter(({ id }) => id !== question.id);
			} else {
				localSelectedQuestions = localSelectedQuestions.concat([question]);
			}

			onChangeSelectedQuestions?.(localSelectedQuestions);
		},
		[selectedQuestions, onChangeSelectedQuestions],
	);

	return (
		<Grid>
			{displayedQuestions.map((question) => (
				<FeedbackQuestionCard
					key={question.id}
					item={question}
					readOnly
					selected={selectedQuestions.includes(question)}
					onSelect={onSelect}
				/>
			))}
		</Grid>
	);
};

export default FeedbackLibraryAccordionItems;
